<app-from-to-display *ngIf="fromToDisplay" [fromToDisplay]="fromToDisplay"></app-from-to-display>
